import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Applicationdate } from "../shared/applicationdate";
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ApplicationdateService {

  applicationdate: Applicationdate ;
  constructor(private httpClient: HttpClient, ) { }

  getBaseUrl() {
    return environment.baseUrl;
  }

  IUDApplicationDate(FormValue: any) {

    // private applicationdate: Applicationdate 
    this.applicationdate= new Applicationdate();

    this.applicationdate.Id = FormValue.value.Id;
    this.applicationdate.BranchId = FormValue.value.frmBranchId;
    this.applicationdate.CurrentDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    // this.applicationdate.CurrentDate = FormValue.value.frmCurrentDate;
    this.applicationdate.ApplicationDate = FormValue.value.frmChangeDate;
    this.applicationdate.Remarks = FormValue.value.frmRemarks;
    this.applicationdate.IsActive = FormValue.value.frmActive;
    this.applicationdate.Flag = FormValue.value.frmFlag;

    this.applicationdate.CompanyId   = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.applicationdate.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.applicationdate.EmployeeId   = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.applicationdate.SaasId       = JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];    
    this.applicationdate.CreatedDate  = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    this.applicationdate.ModifiedDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];

    // this.applicationdate.CreatedDate  = new Date((localStorage.getItem("CreatedDate")));
    // this.applicationdate.ModifiedDate = new Date((localStorage.getItem("ModifiedDate")));

    let body = this.applicationdate;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/ApplicationDateTime/IUD', body, { headers: headers });
  } 

}
